import styled from 'styled-components';
import colors from '../../styles/colors';

export const ModalContainer = styled.form`
	max-widht: 75rem;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #ffffff;
	padding: 2.5rem 1rem;

	@media screen and (min-width: 768px) {
	}
`;

export const HeadingContainer = styled.div`
	margin-bottom: 1.5rem;
`;

export const Main = styled.div`
	width: 100%;
	position: relative;
	display: flex;
	align-items: center;
`;

export const NumberContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
`;

export const AddButtonContainer = styled.div`
	width: 84.5%;
	display: flex;
	justify-content: flex-start;
`;

export const AddButton = styled.div`
	color: ${colors.brandPrimary};
	margin-bottom: 5rem;
	cursor: pointer;

	svg {
		font-size: 1rem;
		margin-right: 10px;
	}
`;

export const SelectsContainer = styled.div`
	width: 95%;
	margin-left: auto;
	display: flex;
	justify-content: space-between;
	margin-bottom: 1.125rem;

	& > div {
		width: 48%;
	}

	label {
		font-weight: 600;
		color: #000;
	}

	@media screen and (max-width: 768px) {
		flex-direction: column;
		& > div {
			width: 95%;
			margin-left: auto;
			margin-bottom: 0.75rem;
		}
	}
`;

export const MainWrapper = styled.div`
	width: 84.5%;
	border-bottom: 1px solid ${colors.neutralForm};
	margin-bottom: 1.125rem;
`;

export const ButtonsContainer = styled.div`
	display: flex;
	& > button {
		margin-right: 1rem;
	}

	@media screen and (max-width: 400px) {
		flex-direction: column;
		& > button {
			margin-right: 0rem;
			margin-bottom: 1rem;
		}
	}
`;
